import React from 'react';
import './Awards.css';

import award1 from './image/awards1.svg'; 
import award2 from './image/awards2.svg'; 
import award3 from './image/awards3.svg';
import award4 from './image/awards4.svg';
import award5 from './image/awards5.svg';

const Awards = () => {
  const awards = [
    {
      title: 'National DeAddiction Seva Award - 2018 Department of Social Justice & Empowerment Ministry of Social Justice & Empowerment',
      img: award3,
    },
    {
      title: 'Shahu, Phule, Ambedkar Award 2019 Social Welfare Department - Government Of Maharashtra',
      img: award4,
    },
    {
      title: 'Rashtrapita Mahatma Gandhi Rajyastariya Vyasanmukti Seva Puraskar 2012-2013',
      img: award2,
    },
    {
      title: 'Women for Change Award - Presented to Varsha Vidya Vilas',
      img: award5,
    },
    {
      title: 'DISPLAY OF HONOURS',
      img: award1,
    },
  ];

  return (
    <div className="awards-container">
      {awards.map((award, index) => (
        <div key={index} className="award-item">
          <h3 className="award-title">{award.title}</h3>
          <img
            src={award.img}
            alt={`Award ${index + 1}`}
            className="award-image"
            onError={(e) => { e.target.onerror = null; e.target.src = 'placeholder.png'; }}
          />
        </div>
      ))}
    </div>
  );
};

export default Awards;
